import { FaStar } from 'react-icons/fa6';
import { Location, Speaker } from '../resources/data/itinerary-test-interfaces';
import accentureIcon from '../resources/images/AccentureIcon.png';
import ClockIcon from '../resources/images/ClockIcon';
import ConferenceSessionIcon from '../resources/images/ConferenceSessionIcon';
import LocationPinIconBlue from '../resources/images/LocationPinIconBlue';
import useWindowDimensions from '../services/utils';
function VoiceItineraryTimelineCard({
  eventName,
  duration,
  location,
  startTime,
  endTime,
  IlianaRecommendation,
  TammyAndMattPick,
  accenturePriority,
  interestMatch,
  speaker,
}: {
  eventName: string;
  duration: string;
  location: Location;
  floor?: string;
  roomName?: string;
  startTime: string;
  endTime: string;
  zone?: string;
  IlianaRecommendation?: boolean;
  TammyAndMattPick?: boolean;
  interestMatch?: string;
  accenturePriority?: boolean;
  speaker?: Speaker;
}) {
  const { width } = useWindowDimensions();

  let sessionType = '';
  let cardBackground = '';
  let locationBackground = '';
  let pinColor = '';
  let textColor = '';
  let sessionIcon = <></>;
  let ClockColor = '';

  if (interestMatch !== 'None') {
    cardBackground = 'bg-green-500 bg-opacity-10';
    locationBackground = 'bg-green-300 bg-opacity-20';
    pinColor = '#013220';
    textColor = 'text-green-800';
    sessionType = `Interest Match - ${interestMatch}`;
    sessionIcon = (
      <div className=" text-yellow-500">
        <FaStar />
      </div>
    );
  } else if (IlianaRecommendation || TammyAndMattPick) {
    cardBackground = 'bg-blue-500 bg-opacity-10';
    locationBackground = 'bg-blue-300 bg-opacity-20';
    pinColor = '#005C57';
    textColor = 'text-teal-800';
    sessionType = "Laila's Pick";
    if (TammyAndMattPick) {
      sessionType = "Tammy & Matt's pick";
    }
    sessionIcon = (
      <div className="text-[#005C57]">
        <FaStar />
      </div>
    );
  } else if (accenturePriority) {
    cardBackground = 'bg-purple-500 bg-opacity-10';
    locationBackground = 'bg-purple-400 bg-opacity-20';
    pinColor = '#5E004D';
    textColor = 'text-fuchsia-950';
    sessionType = 'Accenture Session';
    sessionIcon = (
      <div className="flex h-full w-full items-center justify-center">
        <img src={accentureIcon} className="w-3" />
      </div>
    );
  } else {
    cardBackground = 'bg-gray-500 bg-opacity-10';
    locationBackground = 'bg-gray-400 bg-opacity-20';
    pinColor = 'black';
    textColor = 'text-gray-950';
    sessionType = 'Event';
    sessionIcon = <ConferenceSessionIcon />;
  }

  return (
    <div className="TimelineItemContainer item-start flex p-4  w-full justify-start rounded-lg bg-white bg-opacity-10  md:items-start md:gap-4">
      <div className="TimeFrame flex w-[4rem] flex-col items-end pt-4 ">
        <div className="StartTime font-['Graphik'] text-base font-medium  text-white">
          {startTime}
        </div>
        <div className="EndTime font-['Graphik'] text-sm font-normal text-white">
          {endTime}
        </div>
      </div>
      <div
        className={`EventCard min-h-32 w-full px-4 py-4 ${width < 768 ? cardBackground : ''} flex flex-wrap items-center justify-start gap-4 rounded-lg bg-opacity-10`}
      >
        <div className="Lefthand flex shrink grow basis-0 flex-col items-start justify-start gap-2">
          <div className="EventTitle self-stretch font-['Graphik'] text-base font-medium leading-normal text-white">
            {eventName}
          </div>
          <div className="SpeakerName self-stretch  font-['Graphik'] text-sm font-normal leading-normal text-white">
            {speaker?.name}
          </div>
          <div className={`ChipsEventTypeTime  flex flex-col w-[100%] md:w-[85%] lg:flex-row items-start justify-start gap-2`}>
            <div
              className={`EventType p-2 ${locationBackground} flex items-center justify-start gap-2 rounded-md bg-opacity-20`}
            >
              <div className="Panel h-4 w-4 ">{sessionIcon}</div>
              <div
                className={`Title font-['Graphik'] text-sm font-normal text-white`}
              >
                {sessionType}
              </div>
            </div>
            <div
              className={`Time p-2 ${locationBackground} flex  min-w-20  items-center justify-start gap-2 rounded-md bg-opacity-20`}
            >
              <div className={`AccessTime relative h-4 w-4`}>
                <ClockIcon color={'white'} />
              </div>
              <div
                className={`Title font-['Graphik'] text-sm font-normal text-white`}
              >
                {duration}
              </div>
            </div>
            {/* <div
              className={`Time p-2 ${locationBackground} bg-opacity-20 rounded-md justify-center items-center gap-2 flex flex-grow`}
            >
              <div
                className={`Title ${textColor} text-sm font-normal font-['Graphik']`}
              >
                Score: {score && parseFloat(score).toFixed(2)}
              </div>
            </div> */}
          </div>
        </div>
        <div
          className={`Location flex  w-full md:w-[15rem] items-center justify-start gap-2 self-stretch rounded-md bg-[#4aabd4] bg-opacity-20 px-4 py-2 md:flex-none`}
        >
          <div className="LocationPin relative h-6 w-6">
            <LocationPinIconBlue fillColor={'white'} />
          </div>
          <div className="LocationText">
            {location && (
              <span
                className={` font-['Graphik'] text-sm font-medium leading-tight text-white`}
              >
                {location.title}
                <br />
              </span>
            )}
            {location && location.subtitle && (
              <span
                className={` font-['Graphik'] text-sm font-normal leading-tight text-white`}
              >
                {location.subtitle}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default VoiceItineraryTimelineCard;
